<template>
  <div class="box-content">
     <siteSelect :showArea="showSite" :all="true" @change="siteChange"></siteSelect>
    <div class="right-box">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="6" :sm="8">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="反馈日期">
                <a-range-picker
                  format="YYYY-MM-DD"
                  v-model="dates.feedDate"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onDateFeedDate"
                />
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="8">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系电话">
                <a-input placeholder="请输入联系电话" v-model="queryParam.tel" />
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="8">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态">
                <j-dict-select-tag
                  dictCode="feed_status"
                  v-model="queryParam.status"
                  placeholder="请选择状态"
                ></j-dict-select-tag>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 操作按钮区域 -->
      <div class="table-operator">
        <a-button @click="searchQuery" icon="search" type="primary" ghost>查询</a-button>
        <a-button @click="searchReset" icon="reload">重置</a-button>
        <a-button
          :disabled="addDisabled"
          @click="handleAdd"
          type="primary"
          icon="plus"
          v-if="queryParam.operationType != 4"
          >新增</a-button
        >
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="batchDel">
              <a-icon type="delete" />
              删除
            </a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px">
            批量操作
            <a-icon type="down" />
          </a-button>
        </a-dropdown>
      </div>

      <!-- table区域-begin -->
      <div>
        <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
          <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
          <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
          >项
          <a style="margin-left: 24px" @click="onClearSelected">清空</a>
        </div>

        <a-table
          ref="table"
          size="middle"
          bordered
          rowKey="id"
          :expandIcon="expandIcon"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          @change="handleTableChange"
        >
          <span slot="action" slot-scope="text, record">
            <a href="javascript:;" @click="handleDetail(record)">查看</a>
            <a-divider type="vertical" />
            <a-dropdown>
              <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
              <a-menu slot="overlay">
                <a-menu-item v-if="record.status == 1">
                  <a @click="handleCheck(record)">已处理</a>
                </a-menu-item>
                <a-menu-item v-if="record.status == 1">
                  <a @click="addJob(record)">生成工单</a>
                </a-menu-item>
                <a-menu-item>
                  <a href="javascript:;" @click="handleEdit(record)">编辑</a>
                </a-menu-item>
                <a-menu-item>
                  <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                    <a>删除</a>
                  </a-popconfirm>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </span>
        </a-table>
      </div>
      <!-- table区域-end -->

      <!-- 表单区域 -->
      <feedBack-drawer ref="modalForm" :pagePath="pagePath" @ok="modalFormOk"></feedBack-drawer>
      <YongchunJobOrderDrawer v-if="tenantCode=='yongchun'" ref="jobForm" @ok="modalFormOk"></YongchunJobOrderDrawer>
      <jobOrder-drawer v-else ref="jobForm" @ok="modalFormOk"></jobOrder-drawer>
    </div>
  </div>
</template>

<script>
import FeedBackDrawer from './modules/FeedBackDrawer'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import JobOrderDrawer from './modules/JobOrderDrawer'
import YongchunJobOrderDrawer from "./modules/YongchunJobOrderDrawer"
import siteSelect from '@/components/page/siteSelect'

export default {
  name: 'FeedBackList',
  mixins: [JeecgListMixin],
  components: {
    FeedBackDrawer,
    JobOrderDrawer,
    siteSelect,
    YongchunJobOrderDrawer
  },
  data() {
    return {
      tenantCode:'',
      showSite: true,
      pagePath: '/om/feed/back',
      pageTitle: '反馈单',
      judgmentValue: '1', // 反馈单为管网或者站点名称
      addDisabled: false,
      autoLoadInit:false,
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点',
        align: 'center',
        sorter: true,
      },
      pipeColumn: {
        dataIndex: 'siteName',
        colName: '',
        title: '管网',
        align: 'center',
        sorter: true,
      },
      siteName: '',
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          dataIndex: 'feedDate',
          colName: 'feed_date',
          title: '反馈日期',
          align: 'center',
          sorter: true,
        },
        {
          dataIndex: 'createBy_userName',
          colName: 'create_by',
          title: '反馈人',
          align: 'center',
        },
        {
          dataIndex: 'tel',
          colName: 'tel',
          title: '联系电话',
          align: 'center',
        },
        {
          dataIndex: 'remark',
          colName: 'remark',
          title: '问题和意见',
          align: 'center',
        },
        {
          dataIndex: 'status_dictText',
          colName: 'status',
          title: '状态',
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 200,
          scopedSlots: { customRender: 'action' },
        },
      ],
    }
  },
  created() {
    this.tenantCode = window.localStorage.getItem('projectCode')
    if (window.localStorage.getItem('projectCode')) {
      if (window.localStorage.getItem('projectCode') == 'meitang') {
        this.showSite = false
      }
    }
  },
  computed: {},
  methods: {
    // 1.站点 2.流域 3.管网  由于没有流域所以1.站点2.管网4.区域
    // 站点选择
    siteChange(data) {
      console.log('siteChange', data)
      /* sessionStorage.setItem('siteName', data.data.name == undefined ? data.data.title : data.data.name)
       sessionStorage.setItem('siteId', data.data.id)
       sessionStorage.setItem('operationType', data.data.id)*/
      this.queryParam.siteId = data.data.id

      this.siteName = data.data.name == undefined ? data.data.title : data.data.name
      this.queryParam.scopeId = data.data.id
      this.queryParam.scope = data.scope
      // this.queryParam.operationType = data.scope
      this.siteId = data.data.id

      this.$refs.modalForm.model.siteName = data.data.name == undefined ? data.data.title : data.data.name
      this.$refs.modalForm.model.siteId = data.data.id
      this.$refs.modalForm.model.operationType = data.type
      this.columns.forEach((v, i) => {
        if (v.dataIndex.indexOf('siteName') >= 0 || v.dataIndex.indexOf('pipeName') >= 0) {
          this.columns.splice(i, 1)
        }
      })

      if (1 == data.type) {
        this.addDisabled = false
        this.queryParam.operationType = data.type
        this.judgmentValue = data.type
      } else if (2 == data.type) {
        this.addDisabled = false
        this.queryParam.operationType = data.type
        this.judgmentValue = data.type
      } else if (4 == data.type) {
        ;(this.addDisabled = true),
          // 根据区域
          this.spliceColumn(1 == this.judgmentValue ? this.siteColumn : this.pipeColumn, 1)
      }
      this.loadData()
    },
    onDateFeedDate: function (value, dateArray) {
      this.queryParam.feedDateStart = dateArray[0]
      this.queryParam.feedDateEnd = dateArray[1]
    },
    addJob(record) {
      let param = { originId: record.id, originKey: 'om_feed_back', siteId: record.siteId, siteName: record.siteName }
      this.$refs.jobForm.addJob = true
      this.$refs.jobForm.showCheck = false
      this.$refs.jobForm.disableSubmit = false
      this.$refs.jobForm.edit(param)
    },
    handleCheck(record) {
      this.$refs.modalForm.disableSubmit = false
      this.$refs.modalForm.showCheck = true
      this.$refs.modalForm.edit(record)
    },
    handleEdit: function (record) {
      this.$refs.modalForm.title = '编辑：' + this.pageTitle
      this.$refs.modalForm.disableSubmit = false
      this.$refs.modalForm.showCheck = false
      this.$refs.modalForm.edit(record)
    },
    handleAdd: function () {
      this.$refs.modalForm.title = '新增：' + this.pageTitle
      this.$refs.modalForm.disableSubmit = false
      this.$refs.modalForm.showCheck = false
      this.$refs.modalForm.operationType = this.queryParam.operationType
      this.$refs.modalForm.siteName = this.siteName
      this.$refs.modalForm.siteId = this.siteId
      this.$refs.modalForm.add()
    },
    handleDetail: function (record) {
      this.$refs.modalForm.title = this.pageTitle + '详情'
      this.$refs.modalForm.disableSubmit = true
      this.$refs.modalForm.showCheck = false
      this.$refs.modalForm.edit(record)
    },
    modalFormOk() {
      this.queryParam = {
        scopeId: this.queryParam.scopeId,
        scope: this.queryParam.scope,
        siteId: this.siteId,
        operationType: this.queryParam.operationType,
      }
      this.loadData()
    },
    searchReset() {
      this.queryParam = {
        scopeId: this.queryParam.scopeId,
        scope: this.queryParam.scope,
        siteId: this.siteId,
        operationType: this.queryParam.operationType,
      }
      this.dates = {}
      this.loadData(1)
    },
    // expandIcon属性 关联数据源展开按钮
    expandIcon(props) {
      if (props.record.children) {
        if (props.record.children.length > 0) {
          if (props.expanded) {
            return (
              <a
                style="color: 'black',margin-right:0px"
                onClick={(e) => {
                  props.onExpand(props.record, e)
                }}
              >
                <a-icon type="caret-down" />
              </a>
            )
          } else {
            return (
              <a
                style="color: 'black' ,margin-right:0px"
                onClick={(e) => {
                  props.onExpand(props.record, e)
                }}
              >
                <a-icon style="color:red" type="caret-right" />
              </a>
            )
          }
        } else {
          return <span style="margin-right:0px"></span>
        }
      }
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';

.ant-form-item-label > label {
  color: black;
}

.box-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.right-box {
  width: calc(98% - 300px);
}
</style>
